import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const loadPressContactObjs = makePieActionObjs("load", "Press_Contact")
export const loadPressContactActionDict = loadPressContactObjs.pieDict

const loadPressContactBiographyObjs = makePieActionObjs("load", "Press_Contact_Biography")
export const loadPressContactBiographyActionDict = loadPressContactBiographyObjs.pieDict

// Edit Form
const postPressContactFormObjs = makePieActionObjs("post", "Press_Contact")
export const postPressContactFormActionDict = postPressContactFormObjs.pieDict

const patchPressContactFormObjs = makePieActionObjs("patch", "Press_Contact")
export const patchPressContactFormActionDict = patchPressContactFormObjs.pieDict

// Request Changes
const postRequestChangesPressContactObjs = makePieActionObjs("post", "Request_Changes_Press_Contact")
export const postRequestChangesPressContactActionDict = postRequestChangesPressContactObjs.pieDict

const PressContactActionTypes = {
    ...loadPressContactObjs.actionTypes,
    ...loadPressContactBiographyObjs.actionTypes,
    ...postPressContactFormObjs.actionTypes,
    ...patchPressContactFormObjs.actionTypes,
    ...postRequestChangesPressContactObjs.actionTypes,
    SET_CURRENT_BIO: "SET_CURRENT_BIO",
}

export default PressContactActionTypes
